import { render, staticRenderFns } from "./nssf.vue?vue&type=template&id=096f9f22&scoped=true&"
import script from "./nssf.vue?vue&type=script&lang=js&"
export * from "./nssf.vue?vue&type=script&lang=js&"
import style0 from "./nssf.vue?vue&type=style&index=0&id=096f9f22&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096f9f22",
  null
  
)

export default component.exports